<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card class="neg-escopo neg-modal neg-modal--estreito">
      <q-card-section class="neg-modal__titulo">Reabrir oportunidade</q-card-section>

      <q-card-section class="neg-modal__corpo">
        <p class="neg-sub">{{ explicacao }}</p>
        <q-input
          v-model="motivo"
          autofocus
          type="textarea"
          rows="3"
          label="Motivo da reabertura"
          :error="Boolean(erro)"
          :error-message="erro"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat no-caps label="Cancelar" @click="$emit('update:modelValue', false)" />
        <q-btn unelevated no-caps color="primary" label="Confirmar" @click="confirmar" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: "negocios-modal-motivo",

  emits: ["confirmar", "update:modelValue"],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    origem: {
      type: Object,
      default: null
    },
    destino: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      motivo: "",
      erro: ""
    };
  },
  computed: {
    explicacao() {
      if (!this.origem || !this.destino) {
        return "";
      }

      return (
        "Esta oportunidade está em " +
        this.origem.nome +
        ", que encerra o fluxo. Ela vai para " +
        this.destino.nome +
        " e o motivo fica no histórico."
      );
    }
  },
  watch: {
    modelValue(aberto) {
      if (aberto) {
        this.motivo = "";
        this.erro = "";
      }
    }
  },
  methods: {
    confirmar() {
      if (!this.motivo.trim()) {
        this.erro = "Informe o motivo da reabertura";
        return;
      }

      this.$emit("confirmar", this.motivo.trim());
    }
  }
};
</script>
